<template>
  <div class="fragment">
    <NegativeBalanceAdmin
        v-if="isAdmin"
        :countFilterParams="countFilterParams"
        :filterGetParams="filterGetParams"
        @resetFilter="resetFilter"
        @showMore="showMore"
        @changeFilter="changeFilter"
        @reload="reload"
    />
  </div>

</template>

<script>
  import NegativeBalanceAdmin from "./NegativeBalanceAdmin/NegativeBalanceAdmin";
  import {routeFilter} from "../../../../../mixins/routeFilterMixins/routeFilter";

  export default {
    name: "NegativeBalanceTableBlock",
    components: {
      NegativeBalanceAdmin,
    },

    mixins: [routeFilter],

    data(){
      return {
        forPage: this.$store.getters.getUsersForPage,
        page: 1,
        onePage: 1,

        filterUserId: '',
        filterUserName: '',
        filterBalance: '',

        countFilterParams: 0,
        filterGetParams: {},
      }
    },

    mounted() {
      this.filter()
    },

    methods: {

      getFilterParam() {
        this.filterGetParams = {
          page: this.$route.query.page,
          count: this.$route.query.count,

          userId: this.$route.query.userId,
          userName: this.$route.query.userName,
          userBalance: this.$route.query.userBalance,
        }
      },

      refreshTable() {
        this.filter()
      },

      filter(next = false) {
        this.getFilterParam()

        let url

        // generate main filter if has get params in URL
        let generateMainFilter = this.generateMainFilterFromUrl(next, this)

        // generate other filter if has get params in URL
        this.generateParamsFilterFromUrl(this)

        // Generate filter URL
        url = this.generateFilterUrl(
          generateMainFilter.page,
          generateMainFilter.forPage
        )

        if (next) this.$store.commit('setNextUsersPage', true)
        this.$store.dispatch('fetchUsers', url).then(() => {
          this.$store.commit('setNextUsersPage', false)
          this.$store.commit('setGlobalUpdateTable', false)
        })


        this.checkCountFilter()
      },

      generateFilterUrl(page, forPage) {
        let myQuery = this.createQueryBuilderObject()

        this.generateFilterQueryParams(
          myQuery,
          {
            filterUserId: 'UserId',
            // filterBalance: 'negative_balance',
          },
        )

        myQuery.where('negative_balance', 1)

        // if(this.filterStatus === 'true') myQuery.where('ForbiddenItemKeywordIdiIsEnabled', '1')

        return this.generateGetParamsFromQuery(myQuery, forPage, page)
      },

    }

  }
</script>

<style scoped>

</style>
